<script setup>
  const {} = defineProps(['highlights', 'hide_title', 'solid', 'darken']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <Section>
    <BigTitle h1>
      <slot />
    </BigTitle>
    <Foreground>
      <NewsHighlights :items="highlights" :hide_title="hide_title" :solid="solid" :darken="darken" />
    </Foreground>
  </Section>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  :deep(.title-container) {
    position: relative;
    z-index: $layer-foreground;
  }

  section {
    @include top-padding;
    padding-bottom: px(64);

    background-color: $white;

    &:after {
      content: '';

      position: absolute;
      top: 0;

      width: 100%;
      height: 50%;

      background-color: $black-3;
    }

    @include break-large {
      &:after {
        height: 40%;
      }
    }

    @include break-small {
      &:after {
        height: 35%;
      }
    }
  }
</style>
